module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-03.59b82e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-03.jpg
// module id = 4OZu
// module chunks = 51